// Mock d'API — DÉVELOPPEMENT UNIQUEMENT.
//
// Sert à travailler l'interface de l'espace client sans compte ni backend :
// dans la console du navigateur, `localStorage.ctrl_mock = '1'` puis
// recharger. Toute requête vers l'API reçoit alors une réponse fictive.
//
// Le module entier est retiré du bundle de production (garde NODE_ENV) : en
// ligne, le drapeau n'a aucun effet.
import { BASE } from './api'

const ok = data => new Response(JSON.stringify(data), {
  status: 200, headers: { 'Content-Type': 'application/json' }
})

const DAYS = 5
const since = new Date(Date.now() - DAYS * 864e5).toISOString()
const series = Array.from({ length: 14 }, (_, i) => ({
  date: new Date(Date.now() - (13 - i) * 864e5).toISOString().slice(0, 10),
  count: [42, 61, 55, 80, 73, 120, 98, 66, 90, 140, 112, 95, 130, 48][i]
}))

const ROUTES = {
  '/pair/create.php': { code: 'K7QM-4XPA' },
  '/install/create-token.php': { url: 'https://api.selfcntrl.com/install/mock' },
  '/auth/me.php': { user: { id: 1, name: 'Walter', email: 'test@example.com', timezone: 'Europe/Paris', is_active: true }, stats: {} },
  '/stats/overview.php': { devices: { total: 3, protected: 2, supervised: 1 }, children: 1, days_protected: DAYS, since },
  '/subscription/status.php': { is_active: true, status: 'active', trial_days_left: null, plan: 'monthly' },
  '/streak/status.php': { days: DAYS, sharing: false, alias: null },
  '/cntrl/balance.php': { balance: 640, next_milestone: { dans: 360, bonus: 100 }, cards_available: 0, accruing: true, paused_reason: null, months_held: 3, plan: { per_card: 1000 }, history: [], redemptions: [] },
  '/stats/blocked.php': { total: 1210, range_days: 14, series, categories: [{ key: 'adult', count: 640 }, { key: 'social', count: 380 }, { key: 'other', count: 190 }] },
  '/children/list.php': { children: [{ id: 1, name: 'Moi', filter_level: 'strict', weaning: { days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'], floor: 4, min: 4, delay_hours: 24 }, block_groups: ['gambling'], blocked_domains: [] }] },
  '/schedules/list.php': { schedules: [{ id: 1, name: 'Night', start_time: '23:00', end_time: '07:00', days: 'mon,tue,wed,thu,fri,sat,sun', enabled: 1 }] },
  '/devices/list.php': { devices: [
    { id: 1, child_id: 1, name: 'iPhone 15', platform: 'ios', profile_installed: true, supervised: true, locked_at: '2026-08-01 10:00:00' },
    { id: 2, child_id: 1, name: 'MacBook Air', platform: 'mac', profile_installed: true, supervised: false, locked_at: '2026-08-01 10:00:00' },
    { id: 3, child_id: 1, name: 'PC bureau', platform: 'windows', profile_installed: false, supervised: false, locked_at: null }
  ] },
  '/devices/status.php': { devices: [{ id: 1, active: true, last_seen: since }, { id: 2, active: true, last_seen: since }] },
  '/goals/list.php': { goals: [], weekly_cap: 50 },
  '/goals/history.php': { history: [], totals: {} },
  '/leaderboard/list.php': { rows: [] },
  '/cloudflare/status.php': { active: true },
  '/auth/name.php': { ok: true }
}

export function installDevMock () {
  if (process.env.NODE_ENV === 'production') return
  // '1' = compte avec deux appareils verrouillés ; '2' = rien de verrouillé
  // encore (pour regarder la carte de mise en route).
  let mode = null
  try { mode = localStorage.getItem('ctrl_mock') } catch {}
  if (mode !== '1' && mode !== '2') return
  if (mode === '2') ROUTES['/stats/overview.php'] = { devices: { total: 0, protected: 0, supervised: 0 }, children: 1, days_protected: 0, since }
  try { if (!localStorage.getItem('ctrl_token')) localStorage.setItem('ctrl_token', 'mock') } catch {}
  const real = window.fetch.bind(window)
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : input.url
    if (!url.startsWith(BASE)) return real(input, init)
    const path = url.slice(BASE.length).split('?')[0]
    const hit = ROUTES[path]
    console.info('[mock]', path, hit ? 'ok' : 'vide')
    return new Promise(r => setTimeout(() => r(ok(hit ?? {})), 120))
  }
}
